import store from "@/store/index.js";

export const RolePlugin = {
  install(Vue) {
    Vue.prototype.$allowed = store.getters["user/isAllowed"];
  },
};
